import React, { useEffect, useState } from "react";
import "react-chat-elements/dist/main.css";
import { useTranslation } from "react-i18next";
import {
  getServiceProviderUserChatAction,
  getServiceProviderUserChatDetailsByIdAction,
  sendUserChatMessageAction,
} from "../../../../../../redux/services/service-provider-user-chat/serviceProviderUserChatServices";
import { useDispatch, useSelector } from "react-redux";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import ChatComponent from "../../../../../common/chat-component/ChatComponent";
// import { socket } from "../../../../../../socket";
import useDebounce from "../../../../../../hooks/useDebounce";
import { io } from "socket.io-client";

const UserChat = () => {
  const socketUrl = "wss://reyna-care.reyna-solutions.com/socket.io/";
  // window.location.hostname === "localhost"
  //   ? "http://localhost:5000"
  //   : `${window.location.protocol}//${window.location.host}`;
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /*loading dependencies */
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  /*loading dependencies */

  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  /* table dependencies */
  const {
    serviceProviderUserChat,
    serviceProviderUserChatDetailsById,
    serviceProviderUserChatMessages,
  } = useSelector((state) => state.serviceProviderUserChat);
  const [userChatMessages, setUserChatMessages] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      search: debouncedSearchValue,
    };
    dispatch(getServiceProviderUserChatAction(dataToBeSent, setTableLoader));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  /* on chat list clicked */
  const onChatClicked = (element, setLoading, messageContainerRef) => {
    const selectedServiceProviderUserChatId = element?._id;
    const dataToBeSent = { selectedServiceProviderUserChatId };
    dispatch(
      getServiceProviderUserChatDetailsByIdAction(setLoading, dataToBeSent)
    ).then((apiRes) => {
      setUserChatMessages(apiRes?.messages);
    });

    // socket.emit("chat-room-joined", {
    //   username: userSession?.userName,
    //   user_id: userSession?.userId,
    //   userrole: userSession?.userRole,
    //   room: selectedServiceProviderUserChatId,
    // });
  };
  /* on chat list clicked */

  /* on submit */
  const onSubmit = (values) => {
    if (
      serviceProviderUserChatDetailsById &&
      Object.keys(serviceProviderUserChatDetailsById)?.length !== 0 &&
      serviceProviderUserChatDetailsById?._id !== "" &&
      serviceProviderUserChatDetailsById?._id !== null &&
      serviceProviderUserChatDetailsById?._id !== undefined
    ) {
      const dataToBeSent = {
        ...values,
        conversation_id: serviceProviderUserChatDetailsById?._id,
      };

      dispatch(sendUserChatMessageAction(dataToBeSent, setLoadingMessage)).then(
        (res) => {
          // const selectedServiceProviderUserChatId =
          //   serviceProviderUserChatDetailsById._id;
          // const data = { selectedServiceProviderUserChatId };
          // dispatch(
          //   getServiceProviderUserChatDetailsByIdAction(setDummyLoading, data)
          // );
          handleGetTableData();
        }
      );
    }
  };
  /* on submit */

  // useEffect(() => {
  //   function handleChatMessage(res) {
  //     setUserChatMessages((prevValue) => {
  //       if (prevValue) {
  //         return [...prevValue, res];
  //       } else {
  //         return [res];
  //       }
  //     });
  //   }

  //   socket.on("chat-message", (e) => {
  //     handleChatMessage(e);
  //   });

  //   return () => {
  //     socket.off("chat-message", handleChatMessage);
  //   };
  // }, [userChatMessages, socket]);

  // Socket

  function handleChatMessage(res) {
    setUserChatMessages((prevValue) => {
      if (prevValue?.[0]?.conversation_id === res?.conversation_id) {
        if (prevValue) {
          return [...prevValue, res];
        } else {
          return [res];
        }
      } else {
        return prevValue;
      }
    });
  }

  const selectedServiceProviderUserChatId =
    serviceProviderUserChatDetailsById?._id;

  useEffect(() => {
    const socket = io(socketUrl);
    socket.on("connect", () => {
      console.log("socket connection==", socket.connected); // true
      socket.emit(
        "chat-room-joined",
        {
          username: userSession?.userName,
          user_id: userSession?.userId,
          userrole: userSession?.userRole,
          room: selectedServiceProviderUserChatId,
          metadata: "",
        },

        (data) => {}
      );
    });
    socket.on("chat-message", (res) => {
      handleChatMessage(res);
    });
    return () => {
      // Event listeners cleanup
      socket.emit("chat-room-leaved", (data) => {});
      socket.disconnect();
    };
  }, []);

  return (
    <>
      <ChatComponent
        chatList={serviceProviderUserChat?.data
          ?.map((element) => ({
            ...element?.to_user,
          }))
          .filter((element) => {
            return (
              element?.to_id !== "" &&
              element?.to_id !== null &&
              element?.to_id !== undefined
            );
          })}
        chatMessages={userChatMessages}
        selectedUserDetails={serviceProviderUserChatDetailsById}
        onChatClicked={onChatClicked}
        onSubmit={onSubmit}
        disabledChat={false}
        isChat={true}
        setSearchValue={setSearchValue}
        searchLoading={loading}
      />
    </>
  );
};

export default UserChat;
